<button class="e-suggestion" role="option" (click)="getSearchText()" #button>
    <span class="e-suggestion-value" [innerHtml]="suggestion.textWithHighlight"></span>
    <span class="e-suggestion-type" *ngIf="suggestion.type !== '' && !suggestion?.isSubType">in {{suggestion.type}}</span>
    <span class="e-suggestion-type" *ngIf="suggestion.type !== '' && suggestion?.isSubType">in Sub{{suggestion.type}}</span>
</button>
